import React, { Component } from "react";
import style from "./Statements.module.css";
import { connect } from "react-redux";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import { DatePicker } from "antd";
import * as Yup from "yup";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import {
  fetchStatementsListing,
  fetchpractitioner,
  fetchpatient,
  fetchTransaction,
  paymentDetailsShareViaEmail,
} from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
//import ReactToPrint from "react-to-print";
import api from "../../utils/Api";
import { Link } from "react-router-dom";
import { formatNumberToCurrency } from "../../utils/CommonUtil";
import { Select } from "antd";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";
import invoiceIcon from "../../assets/images/invoice-page-icon.svg";
const { Option } = Select;
/**
 * This function will format the date.
 * @param {date} cell
 */
function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
    }`;
}


// This is initial model for payload.
const model = {
  practitioner_id: "",
  patient_id: "",
  invoice_number: "",
  membership_number: "",
  dateFrom: "",
  dateTo: "",
};

/**
 * This component is created for the statements module.
 */
export class Patient extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...model,
      activeTab: "1",
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      isDataFetched: false,
      paymentForType: 1,
      statementsList: [],
      payment_id: "",
      isModalOpen: false,
      isReportGenerated: true,
    };
    this.setLoader = this.setLoader.bind(this);
  }

  /**
   * This method called when thre component is loaded in the DOM.
   */
  componentDidMount = async () => {
    await this.props.fetchpatient("");
    await this.props.fetchpractitioner("");
    await this.props.fetchStatementsListing(
      this.state.sortBy,
      this.state.page,
      model,
      this.state.paymentForType
    );
    this.setState({
      statementsList: this.props.statementListingData.statementsList.invoice,
    });
    setTimeout(() => {
      if (this.props.statementListingData.statementsList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  };

  /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
      practitioner_id: this.state.practitioner_id,
      patient_id: this.state.patient_id,
      invoice_number: this.state.invoice_number,
      membership_number: this.state.membership_number,
      dateFrom: dateFormatter(this.state.dateFrom),
      dateTo: dateFormatter(this.state.dateTo),
    };
  };

  /**
   * This method will call fetch Statement API with the required params as payload.
   */
  callfetchStatementAPI = async () => {
    this.setState({
      statementsList: [],
    });
    const payload = this.getPayload();
    await this.props.fetchStatementsListing(
      this.state.sortBy,
      this.state.page,
      payload,
      this.state.paymentForType
    );
    if (!this.props.statementListingData.loading) {
      this.setState({
        statementsList: this.props.statementListingData.statementsList.invoice,
      });
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
      }, 1000);
    }
  };

  /**
   * This method will export transaction details to excel file.
   */
  handleExport = async () => {
    this.setState({
      isReportGenerated: false,
    });
    const headers = {
      Accept: "application/xls",
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    const payload = this.getPayload();

    let url = "payment/statement/export?sort_by=" + this.state.sortBy;

    if (payload && payload.practitioner_id) {
      url += "&practitioner_id=" + payload.practitioner_id;
    }
    if (payload && payload.patient_id) {
      url += "&patient_id=" + payload.patient_id;
    }
    if (payload && payload.supplier_id) {
      url += "&supplier_id=" + payload.supplier_id;
    }
    if (payload && payload.dateFrom) {
      url += "&payment_date=gte:" + payload.dateFrom;
    }
    if (payload && payload.dateTo) {
      url += "&payment_date=lte:" + payload.dateTo;
    }

    try {
      const response = await api.get(url, {
        headers: headers,
        responseType: "blob",
      });
      if (response.status == 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Statements.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.setState({
          isReportGenerated: true,
        });
      }
    } catch (error) {
      this.setState({
        isReportGenerated: true,
      });
      console.log("Error for exporting the statements data!", error);
    }
  };

  /**
   * This method will be called when the sorting is changed in the table.
   */
  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState(
      {
        sortName,
        sortOrder,
        sortBy,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method is called when page changes through pagination.
   */
  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false }, () => {
      this.callfetchStatementAPI();
    });
  };

  /**
   * This method will be called when practitioner filter is changed.
   */
  handlePractitionerChange = (filterval) => {
    this.setState(
      {
        practitioner_id: filterval,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method will be called when patient filter is changed.
   */
  handlePatientChange = (filterval) => {

    this.setState(
      {
        patient_id: filterval,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
 * This method will be called when patient filter is changed.
 */
  handleInvoiceNumberChange = (event) => {
    let filterval = event.target.value;

    this.setState(
      {
        invoice_number: filterval,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  handleMembershipNumberChange = (event) => {
    let filterval = event.target.value;

    this.setState(
      {
        membership_number: filterval,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method will be called when date from filter is changed.
   */
  handleDateFrom = (date) => {
    this.setState(
      {
        dateFrom: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method will be called when date to filter is changed.
   */
  handleDateTo = (date) => {
    this.setState(
      {
        dateTo: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method will be called when tab is changed.
   */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState(
        {
          activeTab: tab,
          paymentForType: tab,
          page: 1,
          sortName: undefined,
          sortOrder: undefined,
          sortBy: "",
          isDataFetched: false,
          ...model,
        },
        () => {
          this.callfetchStatementAPI();
        }
      );
    }
  };

  /**
   * This method will be called when view eye icon is clicked.
   * @param {object} val object data of the table row
   */
  viewAction = (val) => {
    this.setState(
      (prevState) => ({
        payment_id: val.payment_id,
        isModalOpen: !prevState.isModalOpen,
      }),
      () => {
        if (this.state.isModalOpen) {
          this.props.fetchTransaction(val.payment_id);
        }
      }
    );
  };

  /**
   * This method will be called when there is not data or data is being fetched to show the loader.
   */
  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  /**
   * This method will be called to format the table data for valid data.
   * @param {string} data of the table column.
   * @returns {string} data or Not available string
   */
  checkValidData = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data;
    }
  };

  /**
   * This method will be called to format the table data for valid data.
   * @param {string} data of the table column.
   * @returns {string} data with first letter capital or Not available string
   */
  detailFormatter = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data.charAt(0).toUpperCase() + data.slice(1);
    }
  };

  /**
   * This method will clear all the filters which are selected.
   */
  handleClearFilters = () => {
    this.setState(
      {
        ...model,
        page: 1,
        sortName: "",
        sortOrder: "",
        sortBy: "",
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This will return filter form HTML for the render method.
   */
  getFilter = () => {

    const patientOptions =
      this.props.patientData && this.props.patientData.patient;

    const practitionerOptions =
      this.props.practitionerData && this.props.practitionerData.practitioner;

    return (
      <Formik initialValues={this.state} enableReinitialize={true}>
        <Form>
          <div className={`row form-group ${style.statementFilterForm}`}>

            <div className="col-sm-6 col-md-6 col-lg-3 mb-3">
              <label>Membership Number</label>
              <Field
                name="membership_number"
                value={this.state.membership_number}
                placeholder="Search By Membership No."
                onChange={this.handleMembershipNumberChange}
                className="form-control"
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3 mb-3">
              <label>Patient</label>
              <Select
                showSearch
                allowClear={true}
                name="patient_id"
                placeholder="Search Patient"
                optionFilterProp="children"
                onChange={(value, event) =>
                  this.handlePatientChange(value, event)
                }
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                value={this.state.patient_id || undefined}
              >
                {patientOptions &&
                  patientOptions.map((element, index) => (
                    <Option key={index} value={element.patient_id}>
                      {element.patient_name}
                    </Option>
                  ))}
              </Select>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3 mb-3">
              <label>Invoice Number</label>
              <Field
                name="invoice_number"
                value={this.state.invoice_number}
                placeholder="Search By Invoice No."
                onChange={this.handleInvoiceNumberChange}
                className="form-control"
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label>Practitioner</label>
              <Select
                showSearch
                allowClear={true}
                name="practitioner_id"
                placeholder="Search Practitioner"
                optionFilterProp="children"
                onChange={(value, event) =>
                  this.handlePractitionerChange(value, "requested_professional")
                }
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                value={this.state.practitioner_id || undefined}
              >
                {practitionerOptions &&
                  practitionerOptions.map((element, index) => (
                    <Option key={index} value={element.practitioner_id}>
                      {element.practitioner_name}
                    </Option>
                  ))}
              </Select>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3 mb-3">
              <label>Date From</label>
              <DatePicker
                name="dateFrom"
                onChange={this.handleDateFrom}
                placeholder="Date From"
                className="form-control"
                value={this.state.dateFrom}
                disabledDate={(d) => !d || d.isAfter(this.state.dateTo)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3 mb-3">
              <label>Date To</label>
              <DatePicker
                name="dateTo"
                onChange={this.handleDateTo}
                placeholder="Date To"
                className="form-control"
                value={this.state.dateTo}
                disabledDate={(d) => !d || d.isBefore(this.state.dateFrom)}
              />
            </div>
          </div>
        </Form>
      </Formik>
    );
  };

  // Adding actions view icon
  actionsFormatter(cell, row) {
    return (
      <div>
        {checkIfPermitted(Permissions.VIEW_INVOICE) && (
          <Link title="View Invoice" className="mr-2" to={{ pathname: `/app/invoicedetails/${row.invoice_id}` }}>
            <img src={invoiceIcon} alt="invoice icon" width="15px" />
          </Link>)}
        {row && row.mediswitch_transaction_id && (
          <Link title="View Claim Details" to={{ pathname: `/app/claimdetails/${row.mediswitch_transaction_id}` }}>
            <i class="fa fa-eye relatedpartylist-edit-icon"></i>
          </Link>)}
      </div>
    );
  }

   rowStyleFormat(row, rowIdx) {
    return { backgroundColor: row && row.response_result_code && (row.response_result_code==6 || row.response_result_code==7)?'#d0e2de':''};
  }
  /**
   * This is render method.
   */
  render() {

    //const statementListingData = this.props.statementListingData.statementsList
    return (
      <div>
        {this.props.loading ? (
          <div className={style.loadingWrapper}>
            <img src={ttmLoader} alt="loader" className={style.loading} />
          </div>
        ) : (
            <div className="inventory-tab-wrapper flex-wrap">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-md-end">
                  <p className={style.clearFilters} onClick={this.handleClearFilters}>Clear Filters</p>
                </div>
                <div className="col-md-12">
                  {this.getFilter()}
                </div>

              </div>

              <div className="row">
                <div className="col-md-12">
                  <BootstrapTable
                    remote={true}
                    bordered={false}
                    data={this.state.statementsList}
                    version="4"
                    search={false}
                    pagination
                    fetchInfo={{
                      dataTotalSize: this.props.statementListingData
                        .statementsList.total,
                    }}
                    options={{
                      searchvalue: "",
                      sortName: this.state.sortName,
                      sortOrder: this.state.sortOrder,
                      onSortChange: this.onSortChange,
                      // onSearchChange: this.onSearchChange,
                      sizePerPage: 10,
                      page: this.state.page,
                      onPageChange: this.onPageChange,
                      noDataText: this.setLoader(),
                    }}
                    trStyle={this.rowStyleFormat}
                  >
                    <TableHeaderColumn
                      isKey
                      dataField="invoice_number"
                      dataSort={true}
                    // width="19%"
                    >
                      Invoice No.
                              </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="practitioner_name"
                      dataSort={true}
                      dataFormat={this.checkValidData}
                    // width="18%"
                    >
                      Practitioner
                                </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="patient_name"
                      dataSort={true}
                      dataFormat={this.checkValidData}
                    // width="18%"
                    >
                      Patient
                                </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="invoice_type"
                      dataSort={true}
                      dataFormat={this.checkValidData}
                    // width="10%"
                    >
                      Mode
                              </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="service_date"
                      dataFormat={dateFormatter}
                      dataSort={true}
                    // width="15%"
                    >
                      Service Date
                              </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="total"
                      dataSort={true}
                      dataAlign="right"
                      dataFormat={formatNumberToCurrency}
                    //  width="10%"
                    >
                      Total Amount (ZAR)
                              </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="amount_paid"
                      dataSort={true}
                      dataAlign="right"
                      dataFormat={formatNumberToCurrency}
                    //  width="10%"
                    >
                      Amount Paid (ZAR)
                              </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="balance"
                      dataSort={true}
                      dataAlign="right"
                      dataFormat={formatNumberToCurrency}
                    //  width="10%"
                    >
                      Balance (ZAR)
                              </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="actions"
                      dataAlign="center"
                      dataFormat={this.actionsFormatter.bind(this)}
                    //width="5%"
                    >
                      Actions
                              </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    statementListingData: state.statementsList,
    initialStatementsData: state.initialStatementsData,
    transactionData: state.transactionDetails,
    loadingTransaction: state.transactionDetails.loading,
    paymentDetailsData: state.paymentDetailsData,
    practitionerData: state.practitioner,
    patientData: state.patient,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStatementsListing: (sortBy, page, payload, paymentForType) =>
      dispatch(fetchStatementsListing(sortBy, page, payload, paymentForType)),
    fetchpractitioner: (practitioner_name) => dispatch(fetchpractitioner(practitioner_name)),
    fetchpatient: (patient_name) => dispatch(fetchpatient(patient_name)),
    fetchTransaction: (payment_id) => dispatch(fetchTransaction(payment_id)),
    paymentDetailsShareViaEmail: (payment_id) =>
      dispatch(paymentDetailsShareViaEmail(payment_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Patient);
